import React from 'react';
import { getStatusName, getStatusClass } from '../../utils/formatters';
import './styles.css';

/**
 * 狀態標籤組件
 * 用於顯示保養單狀態
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.status - 狀態代碼
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 狀態標籤組件
 */
function StatusBadge({ status, className = '' }) {
    const statusClass = getStatusClass(status);
    const statusName = getStatusName(status);

    return (
        <span className={`status-badge ${statusClass} ${className}`}>
            {statusName}
        </span>
    );
}

export default StatusBadge; 